import React from 'react'
import '../layout/Spinner.css'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { compose } from 'redux'
import { Loader } from 'semantic-ui-react'
import AthleteImage from './AthleteImage'

const athleteReduxImageList = 'athleteImageList'

const AthleteImageList = (props) => {

    const athleteImageList = props.athleteImageList

    if (isLoaded(athleteImageList)) {

    return (

        <div className="AthleteImagesContainer">
            <AthleteImage athleteImage={athleteImageList}/>
        </div>
    )

    } else {
        return (

            <div className="SpinnerBackground">
                <div className="SpinnerContainer">
                <Loader size='large' active inline='centered' />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    
    return {
        athleteImageList: state.firestore.data.athleteImageList
    }
  }

export default compose(
  connect(mapStateToProps),
    firestoreConnect((props) => [

        {
            collection: 'athletes',
            doc: props.id,
            subcollections: [
                { collection: 'profile', doc: 'images' }
            ],
            storeAs: athleteReduxImageList
        }
  ])
)(AthleteImageList)